module.exports = __webpack_public_path__ + "img/grimm_in_tea_leaves.53f42661.jpg";